import * as React from "react";
const ExclamationDangerIconWithBG = (props) => (
  <svg
    width={56}
    height={56}
    viewBox='0 0 56 56'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <rect x={4} y={4} width={48} height={48} rx={24} fill='#FEE4E2' />
    <rect
      x={4}
      y={4}
      width={48}
      height={48}
      rx={24}
      stroke='#FEF3F2'
      strokeWidth={8}
    />
    <path
      d='M28 24v4m0 4h.01M38 28c0 5.523-4.477 10-10 10s-10-4.477-10-10 4.477-10 10-10 10 4.477 10 10'
      stroke='#D92D20'
      strokeWidth={2}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
export default ExclamationDangerIconWithBG;
